import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { Shield, Zap, Lock, Smartphone } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'standard' | 'pro'>('pro');
  const handleCheckout = () => {
    if (selected === 'standard') {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44055256498273:1';
    } else {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44055261446241:1';
    }
  };
  return <Section id="pricing" className="bg-gray-50" data-id="element-284">
      <div className="text-center mb-4 md:mb-10" data-id="element-285">
        <h2 className="text-xl md:text-5xl font-black text-dark mb-1 md:mb-4" data-id="element-286">
          Elegí tu Megapack Fútbol Resuelto:
        </h2>
        <p className="text-sm md:text-xl text-gray-700 font-bold" data-id="element-287">
          Las dos opciones incluyen los 6 bonos estratégicos completos
        </p>
      </div>

      <CountdownTimer data-id="element-288" />

      <div className="max-w-3xl mx-auto mt-4 md:mt-10 bg-dark p-3 md:p-8 rounded-xl md:rounded-3xl shadow-2xl" data-id="element-289">
        <div className="flex flex-col gap-2.5 md:gap-4" data-id="element-290">
          {/* Standard Option */}
          <div onClick={() => setSelected('standard')} className={`cursor-pointer border rounded-lg md:rounded-xl p-3 md:p-5 flex items-center gap-2.5 md:gap-4 transition-all ${selected === 'standard' ? 'border-primary bg-primary/10' : 'border-gray-700/50 bg-dark-light/50 hover:border-gray-600'}`} data-id="element-291">
            <div className="flex-shrink-0" data-id="element-292">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selected === 'standard' ? 'border-primary-light' : 'border-gray-600'}`} data-id="element-293">
                {selected === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary-light" data-id="element-294"></div>}
              </div>
            </div>

            <div className="flex-1 min-w-0" data-id="element-295">
              <div className="flex justify-between items-center" data-id="element-296">
                <h3 className="text-white font-black text-xs md:text-lg uppercase leading-tight" data-id="element-297">
                  ⚽ MEGAPACK FÚTBOL RESUELTO
                </h3>
                <div className="text-right flex-shrink-0 ml-2" data-id="element-298">
                  <p className="text-gray-500 line-through text-[9px] md:text-sm font-medium" data-id="element-299">
                    $34.990
                  </p>
                  <p className="text-white font-black text-lg md:text-3xl leading-none" data-id="element-300">
                    $19.990
                  </p>
                </div>
              </div>
              <p className="text-gray-500 text-[10px] md:text-sm mt-0.5" data-id="element-301">
                6 Tomos + 6 Bonos
              </p>
            </div>
          </div>

          {/* PRO Option — visually highlighted */}
          <div onClick={() => setSelected('pro')} className={`cursor-pointer border-2 rounded-lg md:rounded-xl p-3 md:p-5 flex items-center gap-2.5 md:gap-4 transition-all relative overflow-hidden ${selected === 'pro' ? 'border-gold bg-gradient-to-br from-gold/10 via-dark-light to-gold/5 shadow-[0_0_25px_rgba(245,197,24,0.2)]' : 'border-gold/40 bg-dark-light/50 hover:border-gold/70'}`} data-id="element-302">
            {/* Subtle corner glow for PRO */}
            <div className="absolute -top-8 -right-8 w-24 h-24 bg-gold/15 rounded-full blur-2xl pointer-events-none" data-id="element-303"></div>

            <div className="flex-shrink-0 relative z-10" data-id="element-304">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-gold' : 'border-gold/50'}`} data-id="element-305">
                {selected === 'pro' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-306"></div>}
              </div>
            </div>

            <div className="flex-1 min-w-0 relative z-10" data-id="element-307">
              <div className="flex justify-between items-start" data-id="element-308">
                <div className="pr-2" data-id="element-309">
                  <h3 className="text-white font-black text-xs md:text-lg uppercase leading-tight" data-id="element-310">
                    🏆 MEGAPACK + TÁCTICO PRO™
                  </h3>
                  <div className="flex gap-1.5 mt-1" data-id="element-311">
                    <span className="bg-gold text-black text-[8px] md:text-xs font-black px-1.5 md:px-2 py-px md:py-0.5 rounded" data-id="element-312">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-gold/15 text-gold border border-gold/30 text-[8px] md:text-xs font-bold px-1.5 md:px-2 py-px md:py-0.5 rounded" data-id="element-313">
                      AHORRÁS $16.000
                    </span>
                  </div>
                </div>
                <div className="text-right flex-shrink-0 ml-2" data-id="element-314">
                  <p className="text-gray-500 line-through text-[9px] md:text-sm font-medium" data-id="element-315">
                    $43.990
                  </p>
                  <p className="text-gold font-black text-lg md:text-3xl leading-none" data-id="element-316">
                    $27.990
                  </p>
                </div>
              </div>
              <p className="text-gray-400 text-[10px] md:text-sm mt-1" data-id="element-317">
                6 Tomos + 6 Bonos + Fútbol Táctico Pro™
              </p>
            </div>
          </div>
        </div>

        <Button variant="gold" size="lg" fullWidth onClick={handleCheckout} className="mt-4 md:mt-6 py-3 md:py-4 text-sm md:text-2xl font-black uppercase shadow-lg shadow-gold/20" data-id="element-318">
          SÍ, QUIERO {selected === 'pro' ? 'EL MEGAPACK + PRO' : 'MI MEGAPACK'}{' '}
          →
        </Button>

        <p className="text-center text-gray-500 italic text-[10px] md:text-sm mt-2 md:mt-4" data-id="element-319">
          La opción más elegida por instructores que quieren dirigir con
          criterio profesional
        </p>

        <div className="mt-3 md:mt-6 border border-gray-800 rounded-lg md:rounded-xl py-2.5 px-3 md:p-4 bg-dark-light/50 flex flex-wrap justify-center gap-3 md:gap-8 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-320">
          <div className="flex items-center" data-id="element-321">
            <Lock className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-322" />{' '}
            Pago seguro
          </div>
          <div className="flex items-center" data-id="element-323">
            <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-324" />{' '}
            Acceso en 5 min
          </div>
          <div className="flex items-center" data-id="element-325">
            <Shield className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-326" />{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-327">
            <Smartphone className="w-3 h-3 md:w-4 md:h-4 mr-1 text-primary-light" data-id="element-328" />{' '}
            Mercado Pago
          </div>
        </div>
      </div>
    </Section>;
}